import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  GetServiceResponse,
  GetServicesResponse,
} from "../../interface/services.interface";

/**
 * ============================================
 * 🧩 PUBLIC SERVICES SERVICE
 * ============================================
 */

class ServicesService {
  /**
   * 📦 GET ALL SERVICES
   */
  async getServices(): Promise<GetServicesResponse> {
    const response = await apiClient.get<GetServicesResponse>(
      env.SERVICES.PUBLIC
    );

    return response.data;
  }

  /**
   * 📄 GET SINGLE SERVICE
   */
  async getService(id: string): Promise<GetServiceResponse> {
    const response = await apiClient.get<GetServiceResponse>(
      `${env.SERVICES.PUBLIC}/${id}`
    );

    return response.data;
  }
}

export const publicServicesService = new ServicesService();